import axios from "axios"
import behsaTokenService from "services/behsa-token.service"
import technicianTokenService from "services/technician-token.service"
import TokenService from "services/token.service"

export const options = {
    revalidateOnFocus: false,
    shouldRetryOnError: false
}

// instance
export const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    timeout: 30000,
    headers: {
        ...((TokenService?.getLocalAccessToken()) && {
            'authorization': (typeof window !== 'undefined' && `Token ${TokenService?.getLocalAccessToken()}`),
        }),
        "accept-language": "fa"
    }
})

export const generalPlatformInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_GENERAL_PLATFORM_SERVICE_URL,
    timeout: 300000,
    headers: {
        "accept-language": "fa",
    }
})

generalPlatformInstance.interceptors.request.use(config => {
    config.headers[
        'authorization'
    ] = `Bearer ${technicianTokenService.getFirstToken()?.token}`;

    return config;
});

// generalPlatformInstance.interceptors.response.use(response => {
//     return response;
// }, error => {
//     if (error.response?.status === 401) {
//         location.replace(`/signin?return=${location.pathname}`);
//         return TokenService.removeUser();
//     }
//     return Promise.reject(error);
// });


// regular instance without token
export const noAuthInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    timeout: 30000,
    headers: {
        "accept-language": "fa"
    }
})

// behsa project
export const behsaProject = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BEHSA_URL,
    timeout: 30000,
    headers: {
        'authorization': (typeof window !== 'undefined' && `Token ${behsaTokenService?.getLocalAccessToken()}`),
        "accept-language": "fa"
    }
})

// profile
export const profileInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    timeout: 30000,
    headers: {
        'authorization': (typeof window !== 'undefined' && `Token ${TokenService?.getLocalAccessToken()}`),
        "accept-language": "fa"
    }
})

profileInstance.interceptors.response.use(response => {
    return response;
}, error => {
    // when each request by instance response was
    // 401 status -- logout --
    if (error.response.status === 401) {
        location.replace(`/signin?return=${location.pathname}`);
        return TokenService.removeUser();
    }
    return Promise.reject(error);
});

// models instance
export const modelsInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_MODEL_BASE_URL,
    timeout: 30000,
    headers: {
        'authorization': (typeof window !== 'undefined' && localStorage?.getItem("token") && `Token ${localStorage?.getItem("token")}`),
        "accept-language": "fa"
    }
})


// upload service intance
export const uploadServiceInstance = axios.create({
    timeout: 120000,
    baseURL: process.env.NEXT_PUBLIC_UPLOAD_BASE_URL,
    headers: {
        'authorization': (typeof window !== 'undefined' && `Token ${TokenService?.getLocalAccessToken()}`),
        "accept-language": "fa"
    }
})


export const fetcher = (...args) => instance(...args).then(res => res)